import { createV3Queries } from "@query/utils/createV3Queries";
import { backgroundCheckPackagesApi } from "@api";

/**
 * Background-check-package registry — mirrors `BackgroundCheckPackagesApi` 1:1
 * (`/v3/compliance/background-check-packages`, read-only vendor catalog).
 */
export const queriesBackgroundCheckPackages = createV3Queries(
  "backgroundCheckPackagesApi",
  backgroundCheckPackagesApi
);
